import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';
import { ReactNode } from 'react';

import { useAuthorUrlGenerator } from '../../hooks/useUrlGenerator';
import normalizeCardTheme from '../../lib/normalizeCardTheme';

// import { FormattedMessage } from 'react-intl';
// import useFontSize from '../../hooks/useFontSize';

import DocumentsList from '../lists/DocumentsList';
import AuthorSummary from '../summaries/AuthorSummary';

import styles from '../../styles/cards/author-documents-card.module.css';

interface AuthorDocumentsCardProps extends Partial<Author> {
    id?: string | null;
    slug?: string | null;
    linkQuery?: Record<string, unknown> | null;
    name?: string | null;
    description?: string | null;
    image?: Image | null;
    theme?: CardTheme | LegacyCardTheme | null;
    size?: CardSize | null;
    ratio?: CardRatio | null;
    listTitle?: ReactNode | null;
    listProps?: Record<string, unknown> | null;
    listCount?: number | null;
    placeholder?: boolean;
    withoutText?: boolean;
    className?: string | null;
}
function AuthorDocumentsCard({
    id = null,
    slug = null,
    linkQuery = null,
    name = null,
    description = null,
    image = null,
    theme: providedTheme = null,
    size = null,
    ratio = null,
    listTitle = null,
    listProps = null,
    listCount = 3,
    placeholder = false,
    withoutText = false,
    className = null,
}: AuthorDocumentsCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const url = useAuthorUrlGenerator();
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withoutText]: withoutText,
                },
                styles[camelCase(ratio)],
                className,
            ])}
        >
            <AuthorSummary
                id={id}
                slug={slug}
                name={name}
                description={description}
                image={image}
                imagePosition="left"
                className={styles.summary}
                innerClassName={styles.summaryInner}
                imageClassName={styles.summaryImage}
                descriptionClassName={styles.summaryDescription}
                placeholder={placeholder}
                withLink
                link={
                    url(
                        {
                            slug,
                        },
                        linkQuery,
                    ) || '#'
                }
            />
            {listTitle !== null ? <div className={styles.title}>{listTitle}</div> : null}
            <DocumentsList
                query={
                    !placeholder
                        ? {
                              author: id,
                          }
                        : null
                }
                disabled={placeholder}
                cardType="horizontal"
                cardRatio={ratio}
                cardSize={size}
                cardTheme={theme}
                count={listCount}
                columns={1}
                placeholder={placeholder}
                className={styles.list}
                {...listProps}
            />
        </div>
    );
}
export default AuthorDocumentsCard;
